import { ContractApiModel } from '../../../types/models/contract.model';
import { CreateContractApiRequest } from '../../../types/requests/contracts/create-contract.request';
import { DeleteContractApiRequest } from '../../../types/requests/contracts/delete-contract.request';
import { GetContractApiRequest } from '../../../types/requests/contracts/get-contract.request';
import { SearchContractsApiRequest } from '../../../types/requests/contracts/search-contracts.request';
import { UpdateContractApiRequest } from '../../../types/requests/contracts/update-contract.request';
import { CursorPaginatedApiResponse } from '../../../types/responses/cursor-paginated.response';
import { client } from './client';

export const createContract = (params: CreateContractApiRequest) => client.post<ContractApiModel>('/contracts', params);

export const updateContract = ({ contractId, ...params }: UpdateContractApiRequest) =>
  client.patch<ContractApiModel>(`/contracts/${contractId}`, params);

export const getContract = <T extends ContractApiModel>({ contractId, ...params }: GetContractApiRequest) =>
  client.get<T>(`/contracts/${contractId}`, { params });

export const searchContracts = (params: SearchContractsApiRequest) =>
  client.get<CursorPaginatedApiResponse<ContractApiModel>>(`/contracts`, { params });

export const deleteContract = ({ contractId }: DeleteContractApiRequest) =>
  client.delete<void>(`/contracts/${contractId}`);
